"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _NotificationBarWrapper = _interopRequireDefault(require("../../components/NotificationBarWrapper"));

var _context = require("./../../context");

var _actions = require("./../../actions");

var _default = function _default(props) {
  var _useContext = (0, _react.useContext)(_context.NotificationBarContext),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  return _react["default"].createElement(_NotificationBarWrapper["default"], (0, _extends2["default"])({
    dispatch: dispatch,
    registerPlaceholder: _actions.registerPlaceholder,
    unRegisterPlaceholder: _actions.unRegisterPlaceholder,
    placeholders: state.placeholders
  }, props));
};

exports["default"] = _default;